<template>
    <div class="attachments-modal">
        <div class="attachments-modal__title">Attachments</div>
        <div v-if="!isAddNewAttachment"
                class="attachments-modal__edit-wrapper">
            <div class="attachments-modal__add-new-attachment" @click.stop.prevent="() => {}">
            <base-select
                class="attachments-modal__select"
                :options="selectOptions"
                alignLeft
                :titleStyle="{'padding-left': '34px'}"
                :placeholderStyle="{color: '#011627', fontSize: '12px', fontWeight: 'normal'}"
                showTopBorder
                placeholder="Add New"
                placeholderIcon="plusCircle"
                v-model="addNewType"
            />
            </div>
        </div>
        <div class="attachments-modal__attachments-holder">
            <Attachments :attachments="attachments"
                    :isAddNewAttachment="isAddNewAttachment"
                    :briefId="briefId"
                    :isPublishTab="false"
                    :addNewType="addNewType"
                    @addNewChange="changeAddNew"
                    @changeUpdateState="isUpdating = $event"
                    @changeRemovingState="isRemoving = $event"
                    @attachmentUpdated="changeAddNew" 
            />
            <div v-if="isLoaderVisible"
                class="attachments-modal__loader">
                <base-loader/>
            </div>
        </div>
        <div class="attachments-modal__controls"
            v-if="isButtonVisible">
            <button @click.stop="closeAttachments" 
                class="cancel-button"
                :disabled="isRemoving"
            >
                Close
            </button>
        </div>
    </div>
</template>

<script>
import Attachments from './Attachments'

const SELECT_OPTIONS = [
  {
    label: 'Link',
    value: 'link'
  },
  {
    label: 'File',
    value: 'file'
  }
]

export default {
    name: 'AttachmentsModal',
    data() {
        return {
            addNewType: '',
            selectOptions: [...SELECT_OPTIONS],
            isUpdating: false,
            isRemoving: false,
            isDataFetching: false
        }
    },
    props: {
        attachments: Array,
        briefId: String
    },
    components: {
        Attachments
    },
    computed: {
        isAddNewAttachment () {
            return this.addNewType !== ''
        },
        isButtonVisible() {
            return !this.isAddNewAttachment && !this.isUpdating
        },
        isLoaderVisible() {
            return this.isDataFetching && !this.isAddNewAttachment
        }
    },
    watch: {
        attachments () {
            this.isDataFetching = false
        }
    },
    methods: {
        changeAddNew () {
            this.addNewType = '';
            this.$emit('update')
            this.isDataFetching = true
        },
        closeAttachments () {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.attachments-modal {
    padding: 40px 40px 20px;

    &__title {
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        margin: 9px 0 35px;
        color: $rfx-dark-march;
    }

    &__add-new-attachment {
        display: flex;
        position: relative;
    }

    &__attachments-holder {
        position: relative;
        margin-top: 20px;
    }

    &__loader {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, .1);
    }

    &__select {
        width: 160px;

        &::v-deep {
            .select {
                &__placeholder {
                    padding-left: 20px;

                    span {
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    &__attachments-count {
        color: white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #284aff;
        width: 20px;
        height: 20px;
        margin-right: auto;
    }

    &__controls {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;

        .cancel-button {
            margin: 0;
            border: 1px solid $rfx-light-steel;

            &:hover {
                border-color: $rfx-silver;
                background-color: rgba(1,22,39,.1);
            }

            &:disabled {
                opacity: .4;
                pointer-events: none;
            }
        }
    }
}
</style>